"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _TypographyTheme2 = _interopRequireDefault(require("./TypographyTheme"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ButtonTheme = function ButtonTheme(colors, breakpoints) {
  var _TypographyTheme, _TypographyTheme$styl;

  return {
    defaultProps: {
      variant: 'contained',
      disableElevation: true,
      disableRipple: true
    },
    styleOverrides: {
      root: _objectSpread(_objectSpread({}, ((_TypographyTheme = (0, _TypographyTheme2["default"])(colors, breakpoints)) === null || _TypographyTheme === void 0 ? void 0 : (_TypographyTheme$styl = _TypographyTheme.styleOverrides) === null || _TypographyTheme$styl === void 0 ? void 0 : _TypographyTheme$styl.h5) || {}), {}, {
        borderRadius: 24,
        textTransform: 'none',
        height: 40,
        padding: '14px 24px',
        transition: 'none'
      }),
      sizeSmall: {
        padding: '8px 20px',
        height: 32
      },
      contained: {
        backgroundColor: colors.bleuDigital100,
        color: colors.white,
        '&:hover': {
          backgroundColor: colors.hover,
          color: colors.white
        },
        '&:active': {
          backgroundColor: colors.click,
          color: colors.white
        },
        '&.Mui-disabled': {
          backgroundColor: colors.grey10,
          color: colors.grey30
        }
      },
      outlined: {
        padding: '14px 24px',
        borderColor: colors.bleuDigital100,
        borderWidth: 1,
        borderStyle: 'solid',
        backgroundColor: 'transparent',
        color: colors.bleuDigital100,
        '&:hover': {
          backgroundColor: colors.bleuDigital05,
          color: colors.hover
        },
        '&:active': {
          backgroundColor: colors.bleuDigital10,
          borderColor: colors.click,
          color: colors.click
        },
        '&.Mui-disabled': {
          backgroundColor: colors.white,
          borderColor: colors.grey10,
          color: colors.grey30
        }
      },
      text: {
        padding: '14px 24px',
        height: 40,
        color: colors.bleuDigital100,
        borderWidth: 1,
        borderColor: 'transparent',
        borderStyle: 'solid',
        '&:hover': {
          color: colors.bleuDigital100,
          backgroundColor: 'transparent'
        },
        '&:active': {
          color: colors.click,
          backgroundColor: 'transparent'
        },
        '&.Mui-disabled': {
          color: colors.grey30,
          backgroundColor: 'transparent'
        }
      },
      textSizeSmall: {
        padding: '8px 0px',
        height: 32
      },
      iconSizeSmall: {
        '&> *:first-child': {
          fontSize: '16px'
        }
      },
      iconSizeLarge: {
        '&> *:first-child': {
          fontSize: '16px'
        }
      },
      iconSizeMedium: {
        '&> *:first-child': {
          fontSize: '16px'
        }
      },
      label: {
        wordBreak: 'normal'
      }
    }
  };
};

var _default = ButtonTheme;
exports["default"] = _default;